import FormacionDesarrolloContent from "../components/FormacionDesarrollo/FormacionDesarrolloContent";

import FormacionDesarrolloState from "../context/FormacionDesarollo/FormacionDesarrolloState";
import TrainingPlansState from "../context/FormacionDesarollo/TrainingPlansState";

const FormacionDesarrolloScreen = () => {
  return (
    <FormacionDesarrolloState>
      <TrainingPlansState>
        <FormacionDesarrolloContent></FormacionDesarrolloContent>
      </TrainingPlansState>
    </FormacionDesarrolloState>
  );
};

export default FormacionDesarrolloScreen;
